/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-03-25 10:37:55
 */

import { useMemo } from 'react'
import { useAppSelector } from '@/app/hooks'

export const usePhotosData = (dataSource: string) => {
  const photosByLocation = useAppSelector((state) => state.photosByLocation)
  const photosByPrecise = useAppSelector((state) => state.photosByPrecise)
  const photoState = useAppSelector((state) => state.photo)

  const photos: any[] | undefined = useMemo(() => {
    switch (dataSource) {
      case 'legacy':
        return photoState.photos as any[]
      case 'location':
        return photosByLocation.photos as any[]
      case 'precise':
        return photosByPrecise.photos as any[]
    }
  }, [dataSource, photoState, photosByLocation.photos, photosByPrecise.photos])

  const photosNum: number = useMemo(() => {
    switch (dataSource) {
      case 'legacy':
        return photoState.photosNum ?? 0
      case 'location':
        return photosByLocation.photosNum ?? 0
      case 'precise':
        return photosByPrecise.photosNum ?? 0
      default:
        return 0
    }
  }, [
    dataSource,
    photoState,
    photosByLocation.photosNum,
    photosByPrecise.photosNum
  ])

  const checkedPhotos: number[] = useMemo(() => {
    switch (dataSource) {
      case 'legacy':
        return Object.keys(photoState.checkedPhotos || {}).map(Number)
      case 'location':
        return Array.from(photosByLocation.checkedPhotos || [])
      case 'precise':
        return Array.from(photosByPrecise.checkedPhotos || [])
      default:
        return []
    }
  }, [
    dataSource,
    photoState,
    photosByLocation.checkedPhotos,
    photosByPrecise.checkedPhotos
  ])

  const unCheckedPhotos: number[] = useMemo(() => {
    switch (dataSource) {
      case 'legacy':
        return Object.keys(photoState.unCheckedPhotos || {}).map(Number)
      case 'location':
        return Array.from(photosByLocation.unCheckedPhotos || [])
      case 'precise':
        return Array.from(photosByPrecise.unCheckedPhotos || [])
      default:
        return []
    }
  }, [
    dataSource,
    photoState,
    photosByLocation.unCheckedPhotos,
    photosByPrecise.unCheckedPhotos
  ])

  const checkAll: boolean = useMemo(() => {
    switch (dataSource) {
      case 'legacy':
        return photoState.checkAll ?? false
      case 'location':
        return photosByLocation.checkAll ?? false
      case 'precise':
        return photosByPrecise.checkAll ?? false
      default:
        return false
    }
  }, [
    dataSource,
    photoState,
    photosByLocation.checkAll,
    photosByPrecise.checkAll
  ])

  return {
    photos,
    photosNum,
    checkedPhotos,
    unCheckedPhotos,
    checkAll
  }
}
